module.exports = __webpack_public_path__ + "img/4.c1878ae5.jpg";